export { default } from "./HowItWorksPage";
